import {
  isCountries,
  tCountries,
} from 'src/shared/frontendTypes/countries'

export const fallbackCountries: tCountries = [{
  id: 47,
  name: 'Deutschland',
  DhlZone: 1,
  mwst: 19,
  iso: 'DE',
  eu: true,
}]

export const sanitizeCountries = (countries: unknown): tCountries =>
  isCountries(countries) && countries.length > 0
    ? countries
    : fallbackCountries

